<template>
  <v-container>
    <v-row class="pa-12 d-flex">
      <v-spacer class="col-4"></v-spacer>
      <v-card class="ma-4 col-4">
        <v-hover v-slot:default="{ hover }">
          <v-card-text class="text-center">
            <h1 class="heading-1">{{ providerDashboard.file_to_down }}</h1>
            <v-divider class="ma-4"></v-divider>
            <span style="font-size: 20px">not downloaded</span>
            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal display-3 white--text"
                @click="setItemTo('provider_download')"
              >
                Click for Info
              </div>
            </v-expand-transition>
          </v-card-text>
        </v-hover>
      </v-card>
      <v-spacer class="col-4"></v-spacer>
    </v-row>
    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center" height="100%">
        <v-btn class="mt-6" text color="red" @click="sheet = !sheet"
          >close</v-btn
        >
        <v-btn
          class="mt-6"
          text
          color="primary"
          @click="download('selected')"
          :disabled="!selected.length"
          >Download selected</v-btn
        >
        <div class="px-12">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="itemsNeedAction"
            :search="search"
            :single-select="false"
            :loading="loading_bottom_sheet"
            v-model="selected"
            show-select
            dense
            class="scrollable-table"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                v-if="itemTo.includes('download')"
                class="mx-2"
                color="blue"
                name="download"
                :title="'download ' + item.name"
                @click="download(item)"
                >mdi-download</v-icon
              >
            </template>
            <template v-slot:no-data>
              <span color="primary">No data to show you</span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :absolute="true" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    sheet: false,
    itemTo: "",
    search: "",
    selected: [],
    itemToLock: {},
    dialog: false,
    headers: [
      {
        align: "start",
        sortable: false,
        value: "name",
      },
      { align: "center", value: "action", sortable: false },
    ],
    loading: false,
    loading_bottom_sheet: false,
  }),
  computed: {
    ...mapState({
      numbersItem: (state) => state.numbersItem,
      itemsNeedAction: (state) => state.itemsNeedAction,
      user: (state) => state.user,
      providerDashboard: (state) => state.providerDashboard,
    }),
  },
  created: async function () {
    this.loading = true;
    await this.$store.dispatch("setNumbersItemsToNeedAction");
    await this.$store.dispatch("setDashboard", "Provider");
    this.loading = false;
  },
  methods: {
    async download(item) {
      this.loading = true;
      if (item === "selected") {
        this.selected.forEach((el) => {
          this.$store.dispatch("getDownloadLink", {
            father: el.name,
            bucket: el.bucket,
            from_dash: true,
          });
        });
      } else {
        this.$store.dispatch("getDownloadLink", {
          father: item.name,
          bucket: item.bucket,
          from_dash: true,
        });
      }
      this.sheet = false;
      this.loading = false;
    },
    async setItemTo(key) {
      this.$store.commit("resetItemsNeedAction");
      this.loading_bottom_sheet = true;
      this.itemTo = key;
      this.sheet = true;
      await this.$store.dispatch("setItemTo", key);
      this.loading_bottom_sheet = false;
    },
  },
};
</script>
<style scoped>
.scrollable-table {
  height: 27em;
  overflow-y: auto;
}
</style>